import React from 'react';
import QrScanner from 'react-qr-scanner';

const QRScanner = ({ handleScan, handleError, onCameraReady }) => {
    const previewStyle = {
        height: 200,
        width: 170,
        //added borderRadius & objectFit
        borderRadius: '16px',
        objectFit: 'cover',
    };

    const constraints = {
        video: { facingMode: 'environment' }
    };

    return (
        <div>
            <QrScanner
                delay={300}
                style={previewStyle}
                onError={handleError}
                onScan={handleScan}
                onLoad={onCameraReady}
                constraints={constraints}
            />
        </div>
    );
};

export default QRScanner;
